import { Loader2 } from 'lucide-react'

// Full-page loading spinner. Used both as the lazy-route Suspense fallback
// and as the AuthProvider isLoading state — in either case the spinner
// replaces the whole page, so center it vertically.
export function PageLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
    </div>
  )
}
